import React, { useState, useEffect } from 'react';
import { useKeycloak } from '@react-keycloak/web';
import { BYPASS_AUTH } from '../utils/config.js';

// Safe hook: no-op when auth is bypassed
const useSafeKeycloak = () => {
  if (BYPASS_AUTH) {
    return { initialized: true, keycloak: { authenticated: true, login: () => {} } };
  }
  // eslint-disable-next-line react-hooks/rules-of-hooks
  return useKeycloak();
};

const PrivateRoute = ({ children }) => {
  const { keycloak, initialized } = useSafeKeycloak();
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  
  useEffect(() => {
    if (initialized) {
      if (keycloak.authenticated) {
        setIsAuthenticated(true);
      } else {
        keycloak.login();
        setIsAuthenticated(false);
      }
    }
  }, [initialized, keycloak.authenticated]);
  
  // Show loading while checking authentication
  if (!initialized || isAuthenticated === null) {
    return (
      <div className="flex justify-center items-center h-screen bg-gray-50">
        <div className="text-center">
          <div className="w-16 h-16 border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin mb-4 mx-auto"></div>
          <p className="text-gray-600">Verifying authentication...</p>
        </div>
      </div>
    );
  }
  
  // Allow all authenticated users to access the platform
  if (isAuthenticated) {
    console.log('PrivateRoute: User is authenticated, rendering protected content');
    return children;
  }
  
  // This won't normally be reached because keycloak.login() will redirect
  return null;
};

export default PrivateRoute;